"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMatchMediaByWidth = exports.useMatchMedia = void 0;
var react_1 = require("react");
var ssr_1 = require("@r1-frontend/shared/helpers/ssr");
var useIsomorphicLayoutEffect_1 = require("@r1-frontend/shared/hooks/useIsomorphicLayoutEffect");
/**
 * Проверяет переданное медиа-выражение, возвращает результат проверки
 * @param {string} mediaQuery медиавыражение вида: '(max-width: 1000px)'
 * @return {boolean}
 */
exports.useMatchMedia = function (mediaQuery) {
    var _a = __read(react_1.useState(false), 2), isMatch = _a[0], setIsMatch = _a[1];
    var _mql = react_1.useMemo(function () {
        if (ssr_1.isClientSide() && window.matchMedia) {
            return window.matchMedia(mediaQuery);
        }
        else {
            return null;
        }
    }, [mediaQuery]);
    var handleMediaChange = react_1.useCallback(function (e) {
        setIsMatch(e.matches);
    }, []);
    useIsomorphicLayoutEffect_1.useIsomorphicLayoutEffect(function () {
        if (!_mql) {
            return;
        }
        setIsMatch(_mql.matches);
        if ('function' === typeof _mql.addEventListener) {
            _mql.addEventListener('change', handleMediaChange);
        }
        return function () {
            if ('function' === typeof _mql.removeEventListener) {
                _mql.removeEventListener('change', handleMediaChange);
            }
        };
    }, [_mql, handleMediaChange]);
    return isMatch;
};
/**
 * Возвращает медиа-выражение для указанной ширины экрана
 * screenWidth - ширина экрана строкой или числом '768px' или 768
 * isMobileFirst: true - если нужен min-width, по умолчанию max-width
 */
var createMediaQuery = function (screenWidth, isMobileFirst) {
    var width = typeof screenWidth === 'number' ? screenWidth + "px" : screenWidth;
    return "(" + (isMobileFirst ? 'min' : 'max') + "-width: " + width + ")";
};
/**
 * Позволяет передать требуемую ширину экрана вместо медиа-выражения
 * screenWidth - ширина экрана строкой или числом '768px' или 768
 * isMobileFirst: true - если нужен min-width, по умолчанию max-width
 */
exports.useMatchMediaByWidth = function (screenWidth, isMobileFirst) {
    var mq = createMediaQuery(screenWidth, isMobileFirst);
    return exports.useMatchMedia(mq);
};
